const PilotIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
    <path d="M12 22V2" />
  </svg>
);
const AgriIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 4V2" />
    <path d="M12 22v-2" />
    <path d="m17 9 3-3" />
    <path d="m4 20 3-3" />
    <path d="M22 12h-2" />
    <path d="M4 12H2" />
    <path d="m20 20-3-3" />
    <path d="m7 9-3-3" />
    <path d="M12 8a4 4 0 0 0-4 4h8a4 4 0 0 0-4-4Z" />
    <path d="M12 12v10a4 4 0 0 0 4-4h-8a4 4 0 0 0 4 4Z" />
  </svg>
);
const TechnicianIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);
const SurveyingIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M21.21 15.89A10 10 0 1 1 8 2.83" />
    <path d="M22 12A10 10 0 0 0 12 2v10z" />
  </svg>
);
const CameraIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14.5 4h-5L7 7H4a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3l-2.5-3z" />
    <circle cx="12" cy="13" r="3" />
  </svg>
);
const InspectionIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="11" cy="11" r="8" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);
const DroneIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 18.5A2.5 2.5 0 0 1 9.5 16V8a2.5 2.5 0 0 1 5 0v8a2.5 2.5 0 0 1-2.5 2.5Z" />
    <path d="M12 8V2" />
    <path d="M7 16H2" />
    <path d="M17 16h5" />
  </svg>
);
const ArrowUpIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 19V5" />
    <path d="m5 12 7-7 7 7" />
  </svg>
);

const BriefcaseIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M20 6h-4V4c0-1.1-.9-2-2-2h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zM10 4h4v2h-4V4zm10 15H4V8h16v11z" />
  </svg>
);

const UsersIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
  </svg>
);

const CrosshairsIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm0-10C6.48 4 2 8.48 2 14h2c0-4.41 3.59-8 8-8s8 3.59 8 8h2c0-5.52-4.48-10-10-10z" />
  </svg>
);

const ShoppingCartIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z" />
  </svg>
);

const LifeRingIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm-4.95-4.95L12 12l4.95-4.95 2.12 2.12L14.12 12l2.95 2.95-2.12 2.12L12 14.12l-2.95 2.95-2.12-2.12z" />
  </svg>
);

const ArrowRightIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
  </svg>
);

const FaShieldAlt = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M466.5 83.7l-192-80a48.15 48.15 0 00-36.9 0l-192 80C27.7 93.7 16 115.8 16 140.1v203.8c0 32.3 14.2 61.6 37.5 80.5l192 160a48 48 0 0057 0l192-160c23.3-18.9 37.5-48.2 37.5-80.5V140.1c0-24.3-11.7-46.4-29.5-56.4zM256 448c-52.9 0-96-43.1-96-96s43.1-96 96-96 96 43.1 96 96-43.1 96-96 96z"></path>
  </svg>
);
const FaHandshake = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 640 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M434.7 64h-85.9c-8 0-15.7 3-21.6 8.4l-98.3 90c-7.5 6.9-11.9 16.5-11.9 26.6v18.8l-22.4-20.5c-6.6-6.1-15.2-9.4-24-9.4H24c-8.8 0-16 7.2-16 16v128c0 8.8 7.2 16 16 16h142.4c8.8 0 17.4-3.3 24-9.4l22.4-20.5v18.8c0 10.1 4.4 19.7 11.9 26.6l98.3 90c5.9 5.4 13.6 8.4 21.6 8.4h85.9c44.2 0 80-35.8 80-80V144c0-44.2-35.8-80-80-80zM128 288H64v-96h64v96zm384-32c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-32-128c17.7 0 32 14.3 32 32s-14.3 32-32 32-32-14.3-32-32 14.3-32 32-32zm-224 32c0-17.7-14.3-32-32-32s-32 14.3-32 32 14.3 32 32 32 32-14.3 32-32z"></path>
  </svg>
);
const FaRocket = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M505.1 19.1a16.07 16.07 0 00-18-2.2L445.7 32 339.3 16.3A16 16 0 00320 32v112h-48.3c-11-25.5-33.1-45.3-59.7-54.2V32a16 16 0 00-16-16h-16a16 16 0 00-16 16v56.4c-33.3 10-59.5 35.8-68.5 68.6H32a16 16 0 00-16 16v16a16 16 0 0016 16h60.2c10.1 33.1 36.1 59.5 69.8 68.6V480a16 16 0 0016 16h16a16 16 0 0016-16v-56.2c26.6-8.9 48.7-28.7 59.7-54.2H320v112a16 16 0 0019.3 15.7L445.7 480l41.4 15.1a16.07 16.07 0 0018-2.2 16 16 0 008.9-13.8V32a16 16 0 00-8.9-12.9zM224 288a64 64 0 1164-64 64.07 64.07 0 01-64 64z"></path>
  </svg>
);
const FaGlobe = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 496 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm121.3 301.9c-1.2 3.8-5.1 6.1-9 6.1h-40.1c-4.2 0-7.9-2.5-9.5-6.3-1.8-4.2-3.8-8.5-6-12.9-2.7-5.5-7.7-9.2-13.4-9.2h-49.5c-5.7 0-10.7 3.7-13.4 9.2-2.2 4.4-4.2 8.7-6 12.9-1.6 3.8-5.3 6.3-9.5 6.3h-40.1c-3.9 0-7.8-2.3-9-6.1-4.8-15.7-7.8-32-8.4-48.8h198.8c-.6 16.8-3.6 33.1-8.4 48.8zM416 256c0 10.6-1.1 21-3.1 31.1H83.1c-2-10.1-3.1-20.5-3.1-31.1s1.1-21 3.1-31.1h329.8c2 10.1 3.1 20.5 3.1 31.1z"></path>
  </svg>
);
const FaUserCheck = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 640 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M624 208h-64v-64c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v64h-64c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h64v64c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-64h64c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-224-88c52.9 0 96-43.1 96-96s-43.1-96-96-96-96 43.1-96 96 43.1 96 96 96zm-192 32c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm192 64c-61.9 0-112 50.1-112 112v32c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-32c0-61.9-50.1-112-112-112zm-192 0c-61.9 0-112 50.1-112 112v32c0 17.7 14.3 32 32 32h160c17.7 0 32-14.3 32-32v-32c0-61.9-50.1-112-112-112z"></path>
  </svg>
);
const FaSlidersH = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M496 384H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zM16 128h480c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H16C7.2 64 0 71.2 0 80v32c0 8.8 7.2 16 16 16zm480 128H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h480c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16z"></path>
  </svg>
);
const FaTags = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M288 64H32C14.3 64 0 78.3 0 96v192c0 17.7 14.3 32 32 32h256c17.7 0 32-14.3 32-32V96c0-17.7-14.3-64-32-64zm-96 224c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64zm176-64L224 0 80 144h144l144 144zM512 288l-44.8-44.8c-12.5-12.5-32.8-12.5-45.3 0L224 440.8V480c0 17.7 14.3 32 32 32h41.2L512 288z"></path>
  </svg>
);
const FaCalendarCheck = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 448 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M436 160H12c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h424c6.6 0 12 5.4 12 12v40c0 6.6-5.4 12-12 12zm-32-88v-16c0-26.5-21.5-48-48-48h-48c-26.5 0-48 21.5-48 48v16H160v-16c0-26.5-21.5-48-48-48H64c-26.5 0-48 21.5-48 48v16H12C5.4 72 0 77.4 0 84v40c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12V84c0-6.6-5.4-12-12-12h-8zM12 456h424c6.6 0 12-5.4 12-12V192H0v252c0 6.6 5.4 12 12 12zM176.5 352.5l-64-64c-4.7-4.7-12.3-4.7-17 0l-16.1 16.1c-4.7 4.7-4.7 12.3 0 17l88.6 88.6c4.7 4.7 12.3 4.7 17 0l184-184c4.7-4.7 4.7-12.3 0-17l-16.1-16.1c-4.7-4.7-12.3-4.7-17 0l-152.4 152.5z"></path>
  </svg>
);
const FaPlaneDeparture = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 512 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M472 352H40.2c-23 0-34-24.5-18.2-40.2L136 192V48c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v144l114.2 119.8C338 421.5 327 448 304 448H112l-41.4 41.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 480h144c44.2 0 80-35.8 80-80v-48h88c13.3 0 24-10.7 24-24v-48c0-13.3-10.7-24-24-24z"></path>
  </svg>
);
const FaUserTie = () => (
  <svg
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    viewBox="0 0 448 512"
    height="1em"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm-45.7 48C79.8 304 0 383.8 0 482.3 0 498.7 13.3 512 29.7 512h388.6c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"></path>
  </svg>
);

export {
  PilotIcon,
  AgriIcon,
  TechnicianIcon,
  SurveyingIcon,
  CameraIcon,
  InspectionIcon,
  DroneIcon,
  ArrowUpIcon,
  BriefcaseIcon,
  UsersIcon,
  CrosshairsIcon,
  ShoppingCartIcon,
  LifeRingIcon,
  ArrowRightIcon,
  FaShieldAlt,
  FaHandshake,
  FaRocket,
  FaGlobe,
  FaUserCheck,
  FaSlidersH,
  FaTags,
  FaCalendarCheck,
  FaPlaneDeparture,
  FaUserTie,
};
